import React from 'react';

interface AviExtProps {
    width?: number;
    height?: number;
}

export const AviExt = ({ height = 26, width = 26 }: AviExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18367)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#90CB32"
            />
            <path d="M14.762 14.5234V19.5H13.9895V14.5234H14.762Z" fill="white" />
            <path
                d="M11.3882 18.6558L12.7622 14.5234H13.6099L11.8018 19.5H11.2173L11.3882 18.6558ZM10.1064 14.5234L11.4736 18.6558L11.6514 19.5H11.0669L9.26221 14.5234H10.1064Z"
                fill="white"
            />
            <path
                d="M7.58713 15.0908L6.03195 19.5H5.22873L7.11203 14.5234H7.62473L7.58713 15.0908ZM8.88937 19.5L7.33078 15.0908L7.28976 14.5234H7.80588L9.69601 19.5H8.88937ZM8.81076 17.6543V18.2764H6.06613V17.6543H8.81076Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18367">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
